module.exports = __webpack_public_path__ + "img/kjmxlb1.7a731ff6.png";